import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { CreateTestSuitePage } from 'components/test-suites/forms/CreateTestSuitePage'
import { EditTestSuitePage } from 'components/test-suites/forms/EditTestSuitePage'
import { TestSuiteFormContextProvider } from 'components/test-suites/forms/TestSuiteFormContext'
import { getTestSuitesUrls } from 'components/test-suites/test-suites-urls-utils'
import { getCanCreateAndEditTestSuites } from 'components/test-suites/test-suites-utils'
import { TestSuitesPage } from 'components/test-suites/TestSuitesPage'
import { TrackedGremlinRouteElement } from 'components/TrackedGremlinRouteElement'
import useAuth from 'hooks/use-auth'
import { useTranslation } from 'hooks/use-translation'

const TestSuitesIndex: React.FC = () => {
  const { trans } = useTranslation()
  const testSuitesUrls = getTestSuitesUrls()

  const { hasEndpointAccess } = useAuth()

  const canCreateAndEditTestSuites =
    getCanCreateAndEditTestSuites(hasEndpointAccess)

  return (
    <Routes>
      <Route
        index
        element={
          <TrackedGremlinRouteElement
            loggedIn
            component={<TestSuitesPage />}
            name={trans('test_suites')}
          />
        }
      />
      <Route
        element={
          <TrackedGremlinRouteElement
            loggedIn
            component={
              <TestSuiteFormContextProvider>
                <CreateTestSuitePage />
              </TestSuiteFormContextProvider>
            }
            fallbackRedirectTo={testSuitesUrls.base()}
            name="Create a Test Suite"
            shouldRenderRoute={canCreateAndEditTestSuites}
          />
        }
        path="new"
      />
      <Route
        element={
          <TrackedGremlinRouteElement
            loggedIn
            component={
              <TestSuiteFormContextProvider isEdit>
                <EditTestSuitePage />
              </TestSuiteFormContextProvider>
            }
            name={trans('test_suite.edit.page_title')}
          />
        }
        path=":testSuiteId/:tab"
      />
      <Route element={<Navigate to="teams" />} path=":testSuiteId" />
      <Route element={<Navigate to={testSuitesUrls.base()} />} path="*" />
    </Routes>
  )
}

// this needs to be a default export because it is a chunk loaded by webpack
export default TestSuitesIndex
